<script lang="ts">
  import FoojiLogoSmall from "../assets/fooji-logo-small.svg";
  import PATHS from "../lib/constants/routePaths";
  import { getCopy } from "../lib/stores/copy";
  import CookieBanner from "./CookieBanner.svelte";
  import CustomHtml from "./CustomHTML.svelte";

  $: copy = $getCopy("layout") as Record<string, string>;
</script>

<footer
  class="flex w-full justify-start flex-col mb-3 lg:mb-8 py-4 px-4 lg:px-14">

  {#if copy.footerCopy}
    <div class="flex w-full justify-start text-center mb-3 lg:pt-4 lg:w-[calc(100%-640px-116px)]">
      <CustomHtml customHtml={copy.footerCopy} />
    </div>
  {/if}

  <div
    class="flex w-full justify-start items-center flex-col lg:flex-row gap-4 lg:gap-0 mb-3"
  >
    <div class="flex lg:mr-4 gap-2">
      <img src={FoojiLogoSmall} alt="Fooji Logo" class="w-6" />
      <a href="https://fooji.com" target="_blank">{copy.poweredByFooji}</a>
    </div>
    <div class="separator hidden lg:block"></div>
    <ul class="flex gap-x-4 gap-y-2 lg:ml-4 flex-wrap lg:flex-nowrap justify-center lg:justify-normal">
      <li class="whitespace-nowrap"><a href={PATHS.RULES}>{copy.rulesLinkCopy}</a></li>
      <li class="whitespace-nowrap"><a href="https://www.nestleusa.com/terms" target="_blank">Terms & Conditions</a></li>
      <li class="whitespace-nowrap"><a href="https://www.nestleusa.com/privacy" target="_blank">Privacy Policy</a></li>
      <li class="whitespace-nowrap">
        <a href="https://3719b8e5-bbb2-48ec-b39b-d4eb747db867.prod12-care.sprinklr.com" target="_blank">
          {copy.helpLinkCopy}
        </a>
      </li>
      <li class="whitespace-nowrap">
        <a href="https://www.nestleusa.com/privacy_dnsmd" target="_blank">Your Privacy Choices</a>
      </li>
      <li class="whitespace-nowrap">
        <a href="https://www.nestleusa.com/notice-of-collection" target="_blank">Notice of Collection</a>
      </li>
    </ul>
    <CookieBanner />
  </div>
</footer>

<style>
  footer {
    color: var(--color-grayscale-70);
    font-size: var(--footer-font-size);
    font-weight: var(--footer-font-weight);
    margin-bottom: 1rem;
  }

  .separator {
    width: 2px;
    height: 1.25rem;
    background-color: var(--color-grayscale-40);
    margin: 0 1rem;
  }

  @media screen and (min-width: 1024px) {
    footer {
      margin-top: -5.6875rem;
    }
  }
</style>
